import React, { useEffect, useState, useMemo } from 'react';

//composant
import { setAlert } from '../../actions/alert';
import LayoutFermerEnregistrement from '../layout';
import withNavigation from "../../higher-order/navigation";
import Translator from '../../translator.js';

//redux
import { useDispatch, useSelector } from "react-redux";
import { _setIdEnregistrementEntete } from '../../actions/fermer-enregistrement';

//Api
import { getEnregistrementList } from '../../../server/services/fermer-enregistrement-service';

//date
import { format, parseISO } from 'date-fns';

//image
import loadingImage from "../../../../images/loading.svg";


const FermerEnregistrement = ({ goToFermerEnregistrement, language }) => {

  const TEXTS = useMemo(() => Translator(language, 'TXT_FERMER_ENREGISTREMENT_PAGE'), [language]);

  // State
  const authToken = useSelector(state => state.authToken);
  const dispatch = useDispatch()

  const [load, setLoad] = useState(false);
  const [enregistrementList, setEnregistrementList] = useState([])
  const idClient = useSelector((state) => state.fermerEnregistrement.idClient)

  //useEffect
  useEffect(() => {
    //optient la liste des enregistrements
    getEnregistrement()
  }, [])

  //funtions
  const getEnregistrement = async () => {
    setLoad(true);
    try {
      const result = await getEnregistrementList(idClient);
      if (result) {
        setEnregistrementList(result);
        return true;
      } else {
        // gérer le cas où result est null ou undefined
        console.log('Aucun enregistrement trouvé.');
        return false;
      }
    } catch (error) {
      // Gérer les erreurs ici
      console.error('Erreur lors de la récupération des enregistrements:', error);
      return false;
    } finally {
      setLoad(false);
    }
  };


  const navigation = (idEnregistrementEntete, noEnregistrement, dateArrive, dateDepart, hasActivitePeche, hasActiviteChasse) => {
    if (authToken) {
      dispatch(_setIdEnregistrementEntete(idEnregistrementEntete));

      goToFermerEnregistrement({
        idEnregistrementEntete: idEnregistrementEntete,
        noEnregistrement: noEnregistrement,
        dateArrive: dateArrive,
        dateDepart: dateDepart,
        hasActivitePeche: hasActivitePeche === true,
        hasActiviteChasse: hasActiviteChasse === true,
      });

    } else {
      dispatch(setAlert(TEXTS.notConnected, 'danger'));
      window.location.reload();
    }
  };


  const formatActivites = (item) => {
    const activites = item?.activites ?? item?.Activites ?? [];
    return [...new Set(activites.filter(Boolean))];
  };

  const formatDateArrivee = (item) => {
    const raw = item?.dateArrivee ?? item?.dateArrive;
    if (!raw) {
      return '—';
    }

    const date = typeof raw === 'string' ? parseISO(raw) : new Date(raw);
    if (Number.isNaN(date.getTime())) {
      return '—';
    }

    return format(date, "yyyy-MM-dd HH:mm");
  };

  return (
    <LayoutFermerEnregistrement>
      {
        load ?
          <img style={{ height: "100%", filter: "brightness(0) saturate(100%) invert(90%) sepia(1%) saturate(20%) hue-rotate(290deg) brightness(104%) contrast(100%)" }} src={loadingImage} alt={TEXTS.loadingAlt} />
          :
          <div className='contenair-table fe-list'>
            <div className="title-section"><span className="droit-acces-span">{TEXTS.listTitle}</span></div>
            {enregistrementList && enregistrementList.length > 0 ?
              <div className="fe-list-table-wrap">
                <table className="table fe-list-table">
                  <thead>
                    <tr>
                      <th>{TEXTS.colNumero}</th>
                      <th>{TEXTS.colDateArrivee}</th>
                      <th>{TEXTS.colActivites}</th>
                      <th className="fe-list-action-col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {enregistrementList.map((item, index) => {
                      const activites = formatActivites(item);

                      return (
                      <tr key={item.idEnregistrementEntete || index}>
                        <td className="fe-list-num">{item?.noEnregistrement ?? '—'}</td>
                        <td>{format(parseISO(item.dateArrive), "yyyy-MM-dd HH:mm")}</td>
                        <td>
                          {activites.length > 0 ? (
                            <ul className="fe-list-activites">
                              {activites.map((activite, activiteIndex) => (
                                <li key={`${activite}-${activiteIndex}`}>{activite}</li>
                              ))}
                            </ul>
                          ) : (
                            '—'
                          )}
                        </td>
                        <td className="fe-list-action-col">
                          <button
                            type="button"
                            className="fe-list-fermer-btn"
                            onClick={() => navigation(
                              item.idEnregistrementEntete,
                              item.noEnregistrement,
                              item.dateArrive,
                              item.dateDepart,
                              item.hasActivitePeche,
                              item.hasActiviteChasse,
                            )}
                          >
                            {TEXTS.closeBtn}
                          </button>
                        </td>
                      </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              : <p className="fe-list-empty">{TEXTS.noEnregistrement}</p>}
          </div>
      }
    </LayoutFermerEnregistrement>
  );

}

export default withNavigation(FermerEnregistrement)
